import { http } from '../http';
import { registerQuery, useQuery } from '../../utils/DataFetchingClient';
const GET_HOME_OPTIONS = registerQuery({
  fieldName: 'homeOptions',
  args: [],

  fetcher() {
    return http.get('/navconfig/v2/home/options');
  }

});
export const useHomeOptions = () => {
  const {
    data: homeOptions,
    loading: homeOptionsLoading,
    error: homeOptionsError
  } = useQuery(GET_HOME_OPTIONS);
  return {
    homeOptions,
    homeOptionsLoading,
    homeOptionsError
  };
};
export const GET_HOME_KEY = registerQuery({
  fieldName: 'homeKey',
  args: [],

  fetcher() {
    return http.get('/navconfig/v2/home/key');
  }

});
export const useHomeKey = () => {
  const {
    data,
    loading: homeKeyLoading,
    error: homeKeyError
  } = useQuery(GET_HOME_KEY);
  return {
    homeKey: data ? data.homeKey : null,
    homeKeyLoading,
    homeKeyError
  };
};
export const useHomepageUrl = () => {
  const {
    homeOptions,
    homeOptionsLoading,
    homeOptionsError
  } = useHomeOptions();
  const {
    homeKey,
    homeKeyLoading,
    homeKeyError
  } = useHomeKey();
  let overridableHomeKey = homeKey;

  if (!homeKey || homeKey === 'academy') {
    overridableHomeKey = 'dashboards';
  }

  const foundOption = homeOptions && (homeOptions.find(option => option && option.id === overridableHomeKey) || homeOptions.find(option => option && option.id === 'dashboards'));
  return {
    homepage: foundOption ? foundOption.path : null,
    homepageLoading: homeOptionsLoading || homeKeyLoading,
    homepageError: homeOptionsError || homeKeyError
  };
};